export const btnStyle = {
  width: 150,
  height: 36,
  backgroundColor: "#253f66",
  color: "#FFF",
};

export const btnUnderLine = {
  background: "none",
  color: "#253f66",
  textDecoration: "none",
  cursor: "pointer",
  border: "none",
  borderBottom: "1px solid #253f66",
  margin: "0 .25rem",
};

export const btnOutline = {
  minWidth: 150,
  height: "auto",
  color: "#253f66",
  padding: ".5rem",
  border: "2px solid #253f66",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};
